import { useEffect } from "react";
import { useNotifications } from "@/app/providers/NotificationProvider";
import { groupAlertsForNotify } from "../lib/group-alert-notifications";
import { useAlertsSummaryQuery } from "../api/queries";

const PUSHED_STORAGE_KEY = "operational-alert-pushed-ids";

function loadPushedIds(): Set<string> {
  if (typeof window === "undefined") return new Set();
  try {
    const raw = window.sessionStorage.getItem(PUSHED_STORAGE_KEY);
    if (!raw) return new Set();
    return new Set(JSON.parse(raw) as string[]);
  } catch {
    return new Set();
  }
}

function savePushedIds(ids: Set<string>) {
  try {
    window.sessionStorage.setItem(
      PUSHED_STORAGE_KEY,
      JSON.stringify([...ids]),
    );
  } catch {
    // ignore quota errors
  }
}

/** Poll backend alerts และ push ไป NotificationProvider (dedupe ต่อ session, group ตาม rule) */
export function useOperationalAlertsSync() {
  const { notify } = useNotifications();
  const summary = useAlertsSummaryQuery();

  useEffect(() => {
    const alerts = summary.data?.alerts;
    if (!alerts?.length) return;

    const pushed = loadPushedIds();
    const fresh = alerts.filter((alert) => !pushed.has(alert.id));
    if (fresh.length === 0) return;

    const groups = groupAlertsForNotify(fresh);
    let changed = false;

    for (const { notify: input, alertIds } of groups) {
      notify(input);
      for (const alertId of alertIds) {
        pushed.add(alertId);
      }
      changed = true;
    }

    if (changed) savePushedIds(pushed);
  }, [summary.data, notify]);
}
